import type { ComponentEntry } from '../../core/common-types'

const entry: ComponentEntry = {
	componentType: 'UnauthorizedComponent',
	loadComponent: () => import('./UnauthorizedComponent' /* webpackChunkName: "UnauthorizedComponent" */),
}

export default entry
